import React, { useState } from 'react'
import { BillableItemsTable } from './BillableItemsTable'
import { TaxInformation } from './TaxInformation'
import { CommercialDocs } from './CommercialDocs'

export const AltBillingTab = () => {
  const [documentsRefreshToken, setDocumentsRefreshToken] = useState(0)

  return (
    <div>
      <TaxInformation/>
      <BillableItemsTable onDocumentEmitted={() => setDocumentsRefreshToken(v => v + 1)} />
      <CommercialDocs documentsRefreshToken={documentsRefreshToken} />
    </div>
  )
}